import { NextSeo } from 'next-seo'
import React, { useContext } from 'react'

import HNContext from '@/context/HNContext'
import type { IPost } from '@/types/post'

interface IPropTypes {
  post?: IPost
}
export default function PostMeta(props: IPropTypes) {
  const { post } = props

  const { organization } = useContext(HNContext)

  if (!post) return null
  const description = `${post.short_description?.trim()}`
  const title = `${post.title} | ${organization?.name}`

  return (
    <NextSeo
      title={title}
      description={description}
      openGraph={{
        type: 'website',
        locale: 'en_IE',
        url: `${organization?.home_page}/p/${post.slug}`,
        description,
      }}
    />
  )
}
